import { loginUrl } from '@/service/util';
import request from '@/utils/request';

// 查询会员活动阶段完成度
export const queryStageCompleteness = async (locale: string, activityId: string) => {
    return request.get(`${loginUrl(locale)}/website/creditsDay/queryStageCompleteness?activityId=${activityId}`, {
        needToken: true,
    });
};

// 提交感兴趣产品表单
export const createEngagementActivity = async (locale: string, interestedProducts: any) => {
    return request.post(`${loginUrl(locale)}/website/creditsDay/createEngagementActivity?locale=${locale}`, {
        data: {
            interestedProducts: interestedProducts,
        },
        needToken: true,
    });
};

// 查询感兴趣表单
export const queryEngagementActivity = async (locale: string) => {
    return request.get(`${loginUrl(locale)}/website/creditsDay/queryEngagementActivity?locale=${locale}`, {
        needToken: true,
    });
};

// 购买订单记录
export const ordersList = async (locale: string) => {
    return request.post(`${loginUrl(locale)}/shopify/web/customer/orders/list?locale=${locale}`, {
        needToken: true,
    });
};

// 积分兑换记录
export const selectPrizeTypeByUserId = async (locale: string) => {
    return request.get(`${loginUrl(locale)}/integral/web/rewardUserInfo/selectPrizeTypeByUserId?locale=${locale}`, {
        needToken: true,
    });
};

// selectByUserId
export const selectByUserId = async (locale: string) => {
    return request.get(`${loginUrl(locale)}/integral/web/rewardUserInfo/selectByUserId?locale=${locale}`, {
        needToken: true,
    });
};

// fy25

// 根据url获取campaign信息
export const getCampaignInfo = async (locale: string, url: string) => {
    return request.get(`${loginUrl(locale)}/integral/web/rewardCampaign/campaign/get?url=${url}`, {
        needToken: true,
    });
};

// 会员节任务完成度查询
export const getMemberHolidayTask = async (locale: string, campaignId: string) => {
    return request.get(`${loginUrl(locale)}/integral/web/rewardEarnRule/getMemberHolidayTask?campaignId=${campaignId}`, {
        needToken: true,
    });
};

// 查询中奖按钮是否可点击
export const checkWinningList = async (locale: string, activityId: string) => {
    return request.get(`${loginUrl(locale)}/website/creditsDay/enableClick/${activityId}`, {
        needToken: true,
    });
};

// 查询中奖名单
export const getWinningList = async (locale: string, activityId: string) => {
    return request.get(`${loginUrl(locale)}/website/creditsDay/queryWinnerList/${activityId}`, {
        needToken: true,
    });
};

// 会员节站点能量池
export const getMemberHolidayStatistics = async (locale: string) => {
    return request.get(`${loginUrl(locale)}/integral/web/memberHolidayStatistics/2025`, {
        params: {
            stage: 2,
        },
        needToken: true,
    });
};

// 获取积分 (了解品牌: Y25_KNOW_BRAND, 了解会员: Y25_KNOW_MEMBER, 分享故事: Y25_SHARE_STORY)
export const makeMemberHolidayRewardEarn = async (
    locale: string,
    data: { campaignId: string; source: 'Y25_KNOW_BRAND' | 'Y25_KNOW_MEMBER' | 'Y25_SHARE_STORY' },
) => {
    return request.post(`${loginUrl(locale)}/integral/web/memberHolidayRewardEarn/get`, {
        needToken: true,
        data,
    });
};

// 获取积分2
export const makeMemberHolidayRewardEarn2 = async (locale: string, data: { campaignId: string; scene: string }) => {
    return request.post(`${loginUrl(locale)}/integral/web/memberHolidayStatistics/earnEnergy`, {
        needToken: true,
        data,
    });
};
